import { createFileRoute, Link } from "@tanstack/react-router";
import { TackLogo } from "@/components/TackLogo";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/refund")({
  head: () => ({
    meta: [
      { title: "Tack. Refund Policy" },
      { name: "description", content: "Tack's 30-day money-back guarantee and refund process." },
      { property: "og:title", content: "Tack. Refund Policy" },
      { property: "og:description", content: "Tack's 30-day money-back guarantee and how to request a refund." },
    ],
    links: [{ rel: "canonical", href: "https://tack.company/refund" }],
  }),
  component: RefundPage,
});

function RefundPage() {
  return (
    <div className="min-h-screen bg-background">
      <nav className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <Link to="/" aria-label="Tack home" className="inline-block hover:opacity-80 transition-opacity">
            <TackLogo size="md" />
          </Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-display font-bold mb-8">Refund Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: {new Date().toLocaleDateString("en-SE")}</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/90 leading-relaxed">
          <section>
            <h2 className="text-xl font-display font-semibold mb-3">30-Day Money-Back Guarantee</h2>
            <p>We want you to be completely satisfied with Tack. If you're not happy with your purchase, you can request a full refund within <strong>30 days</strong> of your order date — no questions asked.</p>
          </section>

          <section>
            <h2 className="text-xl font-display font-semibold mb-3">How to Request a Refund</h2>
            <p>Lineri AB (Tack) is the seller for all subscription plans and for the physical starter kit. Email us at <a href="mailto:hello@tack.company" className="text-primary underline">hello@tack.company</a> with your account email (or, for the starter kit, your order details) and we will issue the refund. Refunds are paid back through Stripe to the original payment method, normally within 5–10 business days.</p>
          </section>

          <section>
            <h2 className="text-xl font-display font-semibold mb-3">After the 30-Day Period</h2>
            <p>After the 30-day window, you can still cancel your subscription at any time. When you cancel, you'll retain access to Tack until the end of your current billing period. No further charges will be made.</p>
          </section>

          <section>
            <h2 className="text-xl font-display font-semibold mb-3">Annual Subscriptions</h2>
            <p>Annual plans are also covered by the 30-day money-back guarantee from the date of purchase. If you cancel an annual plan after 30 days, your access continues until the end of the annual billing period.</p>
          </section>

          <section>
            <h2 className="text-xl font-display font-semibold mb-3">Contact</h2>
            <p>Questions about refunds? Email us at <a href="mailto:hello@tack.company" className="text-primary underline">hello@tack.company</a>.</p>
          </section>
        </div>
      </main>

      <SiteFooter variant="legal" />
    </div>
  );
}
